export default __webpack_public_path__ + "static/media/plain-sticker-g.d5cc2f52.png";